export default {
    // Stat Count Colors for Charts
    unutilized: 'rgba(255, 65, 54, 0.6)',
    utilized: 'rgba(27, 158, 62, 0.6)',
    available: 'rgba(249, 177, 21, 0.6)',
    expectedNetworkAvg: '#9c9c9c',
}